import Modal, { ModalButton } from './Modal';

// Confirmation before blocking someone
export function BlockDialog({ name, busy, onConfirm, onClose }) {
  return (
    <Modal
      title={`Block ${name}?`}
      onClose={onClose}
      footer={<>
        <ModalButton onClick={onClose}>Cancel</ModalButton>
        <ModalButton danger disabled={busy} onClick={onConfirm}>Block</ModalButton>
      </>}
    >
      <p className="m-0 text-sm leading-relaxed text-text-muted">
        They won't be able to message you or see when you're online, and you won't see their status either.
        They are not told that you blocked them. You can unblock them any time in Settings.
      </p>
    </Modal>
  );
}

// Confirmation before deleting a 1:1 chat for both partners
export function DeleteChatDialog({ name, busy, onConfirm, onClose }) {
  return (
    <Modal
      title="Delete chat?"
      onClose={onClose}
      footer={<>
        <ModalButton onClick={onClose}>Cancel</ModalButton>
        <ModalButton danger disabled={busy} onClick={onConfirm}>{busy ? 'Deleting…' : 'Delete'}</ModalButton>
      </>}
    >
      <p className="m-0 text-sm leading-relaxed text-text-muted">
        All messages in this chat are deleted for you and {name}. This can't be undone.
      </p>
    </Modal>
  );
}

// Confirmation before leaving a group
export function LeaveGroupDialog({ name, isOwner, busy, onConfirm, onClose }) {
  return (
    <Modal
      title={`Leave ${name}?`}
      onClose={onClose}
      footer={<>
        <ModalButton onClick={onClose}>Cancel</ModalButton>
        <ModalButton danger disabled={busy} onClick={onConfirm}>{busy ? 'Leaving…' : 'Leave group'}</ModalButton>
      </>}
    >
      <p className="m-0 text-sm leading-relaxed text-text-muted">
        You won't get messages from this group anymore and can only come back if someone adds you again.
        {isOwner && ' The member who has been in the group the longest becomes the new owner.'}
      </p>
    </Modal>
  );
}
